let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kyuDP")).then(() => parcelRequire('epf88'));